/** Skeleton da DMED — header + navegador de ano + resumo + tabela. */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-5xl animate-pulse flex-col gap-6">
      <div className="h-4 w-24 rounded bg-slate-100" />
      <div className="h-[104px] rounded-[20px] bg-slate-200" />
      <div className="h-11 rounded-xl bg-slate-100" />
      <div className="h-24 rounded-xl bg-slate-100" />
      <div className="grid gap-3 sm:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-24 rounded-xl bg-slate-100" />
        ))}
      </div>
      <div className="h-64 rounded-2xl bg-slate-100" />
    </div>
  );
}
